import { useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { useApp } from "../context/AppContext";
import { CHIP } from "./AdminView";

export default function AdminDashboard({ navigate }) {
  const { applications, deleteApps, bulkStatus } = useApp();
  const [selected, setSelected] = useState([]);
  const [search,   setSearch]   = useState("");
  const [modal,    setModal]    = useState(false);

  const stats = { total:applications.length, pending:applications.filter(a=>a.status==="Pending").length, approved:applications.filter(a=>a.status==="Approved").length, rejected:applications.filter(a=>a.status==="Rejected").length };
  const filtered = applications.filter(a => [a.id,a.full_name,a.email,a.destination,a.service_type,a.agent_name].join(" ").toLowerCase().includes(search.toLowerCase()));

  const toggleSel = (id) => setSelected(p => p.includes(id) ? p.filter(x=>x!==id) : [...p,id]);
  const toggleAll = () => setSelected(selected.length===filtered.length ? [] : filtered.map(a=>a.id));
  const clearSel  = () => setSelected([]);

  const bulkAction = (action) => {
    if (action==="delete") { deleteApps(selected); }
    else                   { bulkStatus(selected, action); }
    clearSel(); setModal(false);
  };

  const StatCard = ({label,val,cls,icon,color}) => (
    <div style={{background:"#fff",borderRadius:14,padding:"20px 22px",border:"1px solid #e4e9f0",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:color}}/>
      <div style={{fontSize:26,marginBottom:10}}>{icon}</div>
      <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:40,fontWeight:700,color:"#0d1f3c",lineHeight:1}}>{val}</div>
      <div style={{fontSize:11,letterSpacing:"1.5px",textTransform:"uppercase",color:"#6b7a90",marginTop:6}}>{label}</div>
    </div>
  );

  return (
    <AdminLayout navigate={navigate} active="dashboard" title="Applications Dashboard">
      {/* STATS */}
      <div className="rgrid-4" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:18,marginBottom:24}}>
        <StatCard label="Total Applications" val={stats.total}    icon="📁" color="linear-gradient(90deg,#4a7fb5,#8a9fc4)"/>
        <StatCard label="Pending Review"      val={stats.pending}  icon="⏳" color="linear-gradient(90deg,#f59e0b,#fbbf24)"/>
        <StatCard label="Approved"            val={stats.approved} icon="✅" color="linear-gradient(90deg,#22c55e,#4ade80)"/>
        <StatCard label="Rejected"            val={stats.rejected} icon="❌" color="linear-gradient(90deg,#ef4444,#f87171)"/>
      </div>

      {/* BULK BAR */}
      {selected.length>0 && (
        <div style={{display:"flex",alignItems:"center",gap:10,background:"#f0f6ff",border:"1.5px solid #4a7fb5",borderRadius:10,padding:"10px 18px",marginBottom:14,flexWrap:"wrap"}}>
          <span style={{flex:1,fontSize:13,fontWeight:600,color:"#0d1f3c"}}><span style={{color:"#4a7fb5"}}>{selected.length}</span> record(s) selected</span>
          {[["✓ Approve","Approved","#dcfce7","#16a34a"],["🔄 In Process","In Process","#e0ecff","#2563eb"],["↺ Pending","Pending","#fef3e2","#d97706"]].map(([l,a,bg,c])=>(
            <button key={a} onClick={()=>bulkAction(a)} style={{padding:"7px 14px",borderRadius:8,fontSize:12,fontWeight:600,background:bg,color:c,border:"none",cursor:"pointer"}}>{l}</button>
          ))}
          <button onClick={()=>setModal(true)} style={{padding:"7px 14px",borderRadius:8,fontSize:12,fontWeight:600,background:"#e05252",color:"#fff",border:"none",cursor:"pointer"}}>🗑 Delete</button>
          <button onClick={clearSel} style={{padding:"7px 14px",borderRadius:8,fontSize:12,fontWeight:600,background:"#eaeef5",color:"#1a2540",border:"none",cursor:"pointer"}}>✕ Cancel</button>
          <span style={{fontSize:11,color:"#8a9bb5",width:"100%"}}>To Reject or ask for Modification, open "View / Update Status" on the record — a reason is required so the agent knows why.</span>
        </div>
      )}

      {/* TABLE */}
      <div style={{background:"#fff",borderRadius:16,border:"1px solid #e4e9f0",overflow:"hidden"}}>
        <div style={{padding:"18px 22px",borderBottom:"1px solid #eaeef5",display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
          <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:600,color:"#0d1f3c"}}>Application Records</h2>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Search name, ID, destination..."
            style={{padding:"8px 14px",border:"1.5px solid #dde3ed",borderRadius:8,fontSize:13,outline:"none",fontFamily:"'DM Sans',sans-serif",width:220}}
            onFocus={e=>e.target.style.borderColor="#4a7fb5"} onBlur={e=>e.target.style.borderColor="#dde3ed"}/>
        </div>

        {filtered.length>0 ? (
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead style={{background:"#f6f8fc"}}>
                <tr>
                  <th style={{padding:"12px 14px",textAlign:"left",width:38}}><input type="checkbox" checked={selected.length===filtered.length&&filtered.length>0} onChange={toggleAll} style={{accentColor:"#4a7fb5"}}/></th>
                  {["App ID","Applicant","Service","Destination","Travel Date","Agent","Submitted","Status","Actions"].map(h=>(
                    <th key={h} style={{padding:"12px 14px",textAlign:"left",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase",color:"#8a9bb5",fontWeight:600,borderBottom:"1px solid #eaeef5"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(app=>(
                  <tr key={app.id} style={{background:selected.includes(app.id)?"#f0f6ff":"transparent"}}>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}><input type="checkbox" checked={selected.includes(app.id)} onChange={()=>toggleSel(app.id)} style={{accentColor:"#4a7fb5"}}/></td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}><strong style={{fontFamily:"'Cormorant Garamond',serif",color:"#0d1f3c",fontSize:13}}>{app.id}</strong></td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}><strong style={{fontSize:13}}>{app.full_name}</strong><br/><span style={{fontSize:11,color:"#6b7a90"}}>{app.email}</span></td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}><span style={{background:"#e0ecff",color:"#2563eb",padding:"3px 9px",borderRadius:6,fontSize:11,fontWeight:500}}>{app.service_type}</span></td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9",fontSize:13}}>{app.destination}</td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9",fontSize:13}}>{app.travel_date}</td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9",fontSize:13}}>{app.agent_name}<br/><span style={{fontSize:11,color:"#6b7a90"}}>{app.agent_agency}</span></td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9",fontSize:12,color:"#6b7a90"}}>{app.submitted_at}</td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}>
                      <span style={{display:"inline-flex",alignItems:"center",gap:4,padding:"4px 10px",borderRadius:20,fontSize:11,fontWeight:600,background:CHIP[app.status]?.bg,color:CHIP[app.status]?.c}}>
                        {CHIP[app.status]?.icon} {app.status}
                      </span>
                    </td>
                    <td style={{padding:"13px 14px",borderBottom:"1px solid #f0f3f9"}}>
                      <div style={{display:"flex",gap:5}}>
                        <button onClick={()=>navigate("view",{app_id:app.id})} style={{padding:"5px 10px",borderRadius:7,fontSize:11,fontWeight:600,background:"#e0ecff",color:"#2563eb",border:"none",cursor:"pointer"}}>View / Update Status</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{padding:60,textAlign:"center"}}>
            <div style={{fontSize:48,marginBottom:14}}>📭</div>
            <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:24,color:"#0d1f3c",marginBottom:8}}>{search?"No results found":"No Applications Yet"}</h3>
            <p style={{fontSize:13,color:"#6b7a90"}}>{search?"Try different search terms":"Applications submitted by agents will appear here."}</p>
          </div>
        )}
      </div>

      {/* DELETE MODAL */}
      {modal && (
        <div onClick={()=>setModal(false)} style={{position:"fixed",inset:0,background:"rgba(10,22,40,0.55)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#fff",borderRadius:16,padding:36,maxWidth:420,width:"90%",textAlign:"center",boxShadow:"0 20px 60px rgba(0,0,0,0.15)"}}>
            <div style={{fontSize:48,marginBottom:14}}>🗑️</div>
            <h3 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:26,color:"#0d1f3c",marginBottom:10}}>Delete Selected Records?</h3>
            <p style={{fontSize:13,color:"#6b7a90",lineHeight:1.7,marginBottom:22}}>This will permanently delete <strong>{selected.length}</strong> application record{selected.length>1?"s":""}. This action cannot be undone.</p>
            <div style={{display:"flex",gap:12,justifyContent:"center"}}>
              <button onClick={()=>setModal(false)} style={{padding:"11px 28px",borderRadius:10,fontSize:13,fontWeight:600,background:"#eaeef5",color:"#1a2540",border:"none",cursor:"pointer"}}>Cancel</button>
              <button onClick={()=>bulkAction("delete")} style={{padding:"11px 28px",borderRadius:10,fontSize:13,fontWeight:600,background:"#e05252",color:"#fff",border:"none",cursor:"pointer"}}>Yes, Delete</button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}
